import liveChanges from "@/store/mercure-live-changes";
import { EventSourcePolyfill } from "event-source-polyfill";
import VueJwtDecode from "vue-jwt-decode";

import store from "@/store/store";
import links from "@/links/links";

export default {
  getEventSource(topics) {
    const eventSourceUrl = this.getEventSourceUrl(topics);
    const mercureJwtToken = localStorage.getItem("mercure-jwt-token");
    return new EventSourcePolyfill(eventSourceUrl, {
      headers: {
        Authorization: "Bearer " + mercureJwtToken,
      },
    });
  },
  getEventSourceUrl(topics) {
    const eventSourceUrl = new URL(links.MERCURE_LINK());
    topics.forEach(topic => {
      eventSourceUrl.searchParams.append("topic", topic);
    });
    return eventSourceUrl;
  },
  modifyInStore(eventData, ormModel, eventDataType) {
    const operationType = this.getOperationType(eventData);
    if (operationType == "upsert") {
      liveChanges.upsertInStore(eventData, ormModel, eventDataType);
    } else if (operationType == "softDelete") {
      liveChanges.deleteFromStore(eventData["id"], ormModel);
    } else if (operationType == "delete") {
      const eventDataId = eventData["@id"].substring(eventData["@id"].lastIndexOf("/") + 1);
      liveChanges.deleteFromStore(eventDataId, ormModel);
    }
  },
  getOperationType(eventData) {
    if (eventData["@type"] && eventData["@id"] && !eventData["deleted"]) {
      return "upsert";
    } else if (eventData["@type"] && eventData["@id"] && eventData["deleted"]) {
      return "softDelete";
    } else if (!eventData["@type"] && eventData["@id"]) {
      return "delete";
    } else {
      return "";
    }
  },
  case401Error(eventSource) {
    eventSource.onerror = event => {
      if (event.status == 401) {
        this.checkMercureToken(event);
      }
    };
  },
  checkMercureToken(event) {
    let authorizationHeader = event.target.headers.Authorization;
    let mercureToken = authorizationHeader.replace("Bearer ", "");
    const jwtDecoded = VueJwtDecode.decode(mercureToken);
    // get current time in ms ... mercure jwt token format
    const currentTime = new Date().valueOf() / 1000;
    // if current time is bigger than mercure jwt token expiration date, login again
    if (currentTime > jwtDecoded.exp) {
      store.dispatch("auth/tokenRefresh").catch(err => {
        console.error(err);
      });
    }
  },
};
